import axios from 'axios';
import { config } from '../config';

class CurbsideAPIService {
  private readonly api: any;

  constructor() {
    console.log(config.apiEndpoints.api);
    this.api = axios.create({
      baseURL: config.apiEndpoints.api,
    });
  }

  private async refreshToken(): Promise<string> {
    try {
      const response = await this.api.post('/auth/refresh-token', {
        refreshToken: localStorage.getItem('refreshToken'),
      });
      return response.data.accessToken;
    } catch (error) {
      console.error('Failed to refresh token:', error);
      throw error;
    }
  }

   async stsAuth(): Promise<string> {
    try {
      
      const response = await this.api.post('/authentication/sts', null, true);
      return response.data;
    } catch (error) {
      console.error('Failed to refresh token:', error);
      throw error;
    }
  }

  async checkToken() {
    const accessToken = localStorage.getItem('userToken');
    if (!accessToken) {
      try {
        const newAccessToken = await this.refreshToken();
        localStorage.setItem('userToken', newAccessToken);
      } catch (error) {
        console.error('Failed to refresh token:', error);
      }
    }
  }

  async get(endpoint: string, params: Record<string, any> = {}): Promise<any> {
    try {
      let config: { headers: { Authorization: string } } = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        },
      };

      const response = await this.api.get(endpoint, { params, ...config });
      return response.data;
    } catch (error) {
      console.error('GET request error:', error);
      throw error;
    }
  }

  async post(
    endpoint: string, 
    data: Record<string, any>, 
    isAuthCall: boolean = false
  ): Promise<any> {
    try {
      let config: { headers?: { Authorization: string } } = {};
      if (!isAuthCall) {
        config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        };
      }
      const response = await this.api.post(endpoint, data, config);
      return response.data;
    } catch (error) {
      console.error('POST request error:', error);
      throw error;
    }
  }

  async patch(
    endpoint: string, 
    data: Record<string, any>, 
    isAuthCall: boolean = false
  ): Promise<any> {
    try {
      let config: { headers?: { Authorization: string } } = {};
      if (!isAuthCall) {
        config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        };
      }
      const response = await this.api.patch(endpoint, data, config);
      return response.data;
    } catch (error) {
      console.error('PATCH request error:', error);
      throw error;
    }
  }

  async put(
    endpoint: string, 
    data: Record<string, any>, 
    isAuthCall: boolean = false
  ): Promise<any> {
    try {
      let config: { headers?: { Authorization: string } } = {};
      if (!isAuthCall) {
        config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        };
      }
      const response = await this.api.put(endpoint, data, config);
      return response.data;
    } catch (error) {
      console.error('POST request error:', error);
      throw error;
    }
  }

  async delete(
    endpoint: string, 
    data: Record<string, any>, 
    params: Record<string, any> = {}
  ): Promise<any> {
    try {
      const config: {
        headers: { Authorization: string };
        params: Record<string, any>;
        data: Record<string, any>;
      } = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        },
        params,
        data,
      };

      const response = await this.api.delete(endpoint, config);
      return response.data;
    } catch (error) {
      console.error('Delete request error:', error);
      throw error;
    }
  }

  async deleteNew(endpoint: string): Promise<any> {
    try {
      const config: { headers: { Authorization: string } } = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        },
      };

      const response = await this.api.delete(endpoint, config);
      return response.data;
    } catch (error) {
      console.error('Delete request error:', error);
      throw error;
    }
  }
}

const curbsideAPIService = new CurbsideAPIService();
export default curbsideAPIService;
